import { render, staticRenderFns } from "./FreeAthleteModal.vue?vue&type=template&id=2edc59de&"
import script from "./FreeAthleteModal.vue?vue&type=script&lang=js&"
export * from "./FreeAthleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports